import tool from "./tools";
import { i18n } from './../../../plugins/i18n.js'

export default {
  Rezervasyon() {
    return {
      pNR_No: 0,
      MisafirIsmiKontrolEdilmesin:false,
      Status:0,
      FaturaBilgileri: [],
      kayitTarihi: tool.Now_yyyy_MM_dd(),
      cariKod: {
        id: "",
        kod: "",
        isim: "",
        isimAra: ""
      },
      rezVeren: "",
      masrafMerkezi: {
        id: "",
        kod: "",
        isim: "",
        isimAra: ""
      },
      anaTip: 0,
      ulke: null,
      karsiRezKod: "",
      turKod: "",
      acenteDepartman: {
        id: "",
        kod: "",
        isim: "",
        isimAra: ""
      },
      hizmetNo: "",
      referansKod: "",
      adresler: [],
      kalemler: [],
      odemeler: [],
      toplamTL: {
        satis: 0,
        alis: 0,
        komisyon: 0,
        iskonto: 0
      },
      opsiyonluMusteri: false,
      opsiyonTarihi: null,
      opsiyonSaati: null,
      acente: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null,
      },
    }
  },
  Adres() {
    return {
      id: -1,
      kisiTip: 0,
      kisiSira: -1,
      yas: 0,
      profilId: 0,
      sicilId:0,
      tcKimlikNo: "",
      uyeNo: "",
      adSoyad: "",
      adres: "",
      dogumTarihi: null,
      cinsiyet: "",
      telefon1: "",
      gsm: "",
      eMail: "",
      lastName:"",
      firstName:"",
    }
  },
  Cinsiyet() {
    return [{
        text: i18n.tc('Male'),
        value: 'E'
      },
      {
        text: i18n.tc('Female'),
        value: 'K'
      }
    ]
  },

  // KisiTip: [{
  //   Kod: 0,
  //   Aciklama: "Yetişkin"
  // }, {
  //   Kod: 1,
  //   Aciklama: "Çocuk 1"
  // }],



  IcDis: [{
      text: i18n.tc('Domestic'),
      value: 0
    },
    {
      text: i18n.tc('International'), 
      value: 1
    }, {
      text: i18n.tc('All'),
      value: null
    }
  ],


  Opsiyon: [{
      text: i18n.tc('All'),
      value: 0
    }, {
      text: i18n.tc('With-Optional'), 
      value: 1
    },
    {
      text: i18n.tc('Without-Optional'), 
      value: 2
    }
  ],

  Para() {
    return {
      paraBirimi: "TL",
      kur: 1,
      kurTarihi: null
    }
  },

  Kalem() {
    return {
      islemRef: 0,
      saticiEntegrasyon: null,
      entTip: null, //bu alanlar farklı sistemlerden copere entegre edilecek alanlar için eklendi PaxDrive-HotelRunner vb.
      entId: null,
      donem1: null,
      donem2: null,
      satis: {
        KDVOran: 0
      },
      alis: {
        KDVOran: 0
      },
      komisyon: {
        KDVOran: null,
        tutar: 0
      },
      acenteKomisyon: {
        paraBirimi: null,
        kur: 0,
        tutar: 0,
        KDVOran: 0,
        iskonto:0,
        NetTutar:0,
        KDVTutar:0,
        IskontoKDVTutar:0,
        DovizTutar:0
      },
      iskonto: {
        oran: 0,
        tutar: 0,
        iskontoSebebi: null,
      },
      odeyenTaraf: 1,
      aciklama: null,
      tedarikciAciklama: null,
      turOperatoru: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null,
      },
      departman: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null,
      },
      kdvID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      kdvMuafiyetID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      entegrasyonKodu: null,
      maliyetCariKod: {
        id: null,
        kod: null,
        isim: null,
        tip: null
      },
      saticiTip: 1,
      kisiSira: [],
      yet_Satis: 0,
      co1_Satis: 0,
      co2_Satis: 0,
      co3_Satis: 0,
      co4_Satis: 0,
      ekY_Satis: 0,
      yet_Alis: 0,
      co1_Alis: 0,
      co2_Alis: 0,
      co3_Alis: 0,
      co4_Alis: 0,
      ekY_Alis: 0,

      yet_KisiSayisi: 0,
      co1_KisiSayisi: 0,
      co2_KisiSayisi: 0,
      co3_KisiSayisi: 0,
      co4_KisiSayisi: 0,
      ekY_KisiSayisi: 0,

      satici: {
        id: null,
        kod: null,
        isim: null,
        tip: null,
        YurtIci_YurtDisi: null,
        KDV: 0,
      },
      alisPara: this.Para(),
      satisPara: this.Para(),
      komisyonPara: this.Para(),
      komisyonYuzdeTip: 0,
      komisyonYuzde: 0,
      komisyonTutar: 0,
      P_RP: 'P',
      KKartNo:null,
      KKartOdemeTipi:0,
      masrafMerkezi: {
        id: null,
        kod: null,
        isim: null,
        tip: null
      },
      kalemOtel: {
        odaTipi: {
          id: null,
          kod: null,
          isim: null,
          tip: null
        },
        pansiyon: 0,
        girisSaati: '12:00',
        konum: null,
        RP: 'T',
        KomKDVHaric:false,
        KomKahvaltiHaric:false,
        KomOgleYemegiHaric:false,
        KomAksamYemegiHaric:false,
        KonaklamaVergisiVar:false,
        odaSayi: 1,
        kontenjan: false,
        freeKisi: 0,
        fiyatKodu: {
          id: null,
          kod: null,
          isim: null,
          tip: null
        },
      },
      kalemArac: {
        tip: null,
        ucusNo: null,
        ucusSaat: null,
        tasimaTipi: null,
        bolge: null,
        nerden: null,
        nereye: null,
        arac: null,
        aracAdet: null,
        rehberDili: null,
        rehberAdet: null,
        seferNo: null,
        seferId: null,
        seferSaat: null,
        ADT: null,
        tasimaTipRef: null,
        rehber: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null
        },
        pinCode: null,
        otelKod: null,
        SoforTahsilat: null,
        seferVarisId: null,
        odaNo: null,
        transferDurumu: null,

      },
      kalemRestaurant:{
        tip: null,
        ResKod: null,
        Saat: null,
        Menu: null,
        Restaurant:null,
        ResCari:null,
        ResRezTar:null,
        ResNo:null,
        ResCariOnay:0,
        Acente:null,
        AcenteCari:null,
        AcenteRezTar:null,
        AcenteNo:null,
        AcenteCariOnay:0,
        DeadLine:0,
        PaketDisi:0
      },
       kalemMuze: {
        isAciklama: null,
        Satici: null,
        IsKodu: null,
        Bolge: null,
        Saat: null,
        DeadLine: null,
        PaketDisi: null,
        PaketId:null,
        PaketFiyatGrupId:null,
        PaketAltGrupId:null
      },
      kalemDiger: {
        isAciklama: null,
        Satici: null,
        IsKodu: null,
        Bolge: null,
        Saat: null,
        DeadLine: null,
        PaketDisi: null,
        PaketId:null,
        PaketFiyatGrupId:null,
        PaketAltGrupId:null
      },
      kalemRentACar: {
        teslimKm: null,
        firma: null,
        arac: null,
        aracAdet: null,
        kategori: null,
        alisYeri: null,
        alisSaat: null,
        teslimYeri: null,
        teslimTarihi: null,
        gun: null,
        RCR: null,
        RCRCari: null,
        RCRRezTar: null,
        RCRNo: null,
        RCRCariOnay: null,
        acente: null,
        acenteCari: null,
        acenteRezTar: null,
        acenteNo: null,
        acenteCariOnay: null,
        teslimSaat: null,
        alisTarih: null,
        turOperatoru: null,
        dropUcreti: 0,
        bebekKoltugu: 0,
        otomatikVites: 0,
        klima: 0,
        checkDropUcreti: false,
        checkBebekKoltugu: false,
        checkOtomatikVites: false,
        checkKlima: false,
        cocukKoltugu: 0,
        iptalSigortasi: 0,
        temizlik: 0,
        navigation: 0,
        diger: 0,
        checkCocukKoltugu: false,
        checkIptalSigortasi: false,
        checkTemizlik: false,
        checkNavigation: false,
        checkDiger: false,
        musteriTeslimTarihi: null,
        musteriTeslimSaati: null,
        saatOpsiyonu: null,
        deadLine: null,
        dizel: 0,
        checkDizel: false,
      },
      kalemVize: {
        Tip: 'NONE',
        VizeCesidi: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null
        },
        VizeNo: null,
        DeadLine: null,
        KonsVerilisTarihi: null,
        KonsCikisTarihi: null,
        Durum: null,
        TeslimTipi: null,
        TeslimEden: null,
        TeslimAlan: null,
        TeslimTarihi: null,
        KargoIsmi: null,
        KargoFisNo: null,
        KargoTeslimEdilenSube: null,
        KargoTeslimEdilenTel: null,
        KargoTeslimEdilecekSube: null,
        KargoTeslimEdilecekTel: null,
        PspCocukVar: false,
        PspCocukVizeIstiyor: false,
        Cocuk1Kod: null,
        PspOfsTeslimAlan: null,
        PspOfsTeslimTarihi: null,
        PspMusTeslimEden: null,
        PspMusTeslimTarihi: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
        VizeDurumu: '1',
        KonsTahCikisTarihi: null,
        AlisKDV: null,
        RandevuZamani: null,
        IstenenDonem1: null,
        IstenenDonem2: null,
        GirisTipi: '0',
        VizeSorumlusu: null,
        MailGonTarihi: null,
      },
      kalemSigorta: {
        Tip1: null,
        Tip2: null,
        PoliceNo: null,
        DeadLine: null,
        PoliceTarihi: null,

      },
      kalemFeribot: {
        Tip1: 0,
        Tip2: 0,
        RezNo: null,
        FeribotTuru: null,
        KamaraTipi: null,
        Nerden: null,
        Nereye: null,
        Arac1: null,
        Arac2: null,
        Arac3: null,
        Plaka1: null,
        Plaka2: null,
        Plaka3: null,
        Alis1: 0,
        Alis2: 0,
        Alis3: 0,
        Satis1: 0,
        Satis2: 0,
        Satis3: 0,
        KalkisZamani: null,
        DonusZamani: null,
        DeadLine: 0,
        SeferDeparID: 0,
        SeferVarisID: 0,
        GidisIslemRef: 0,
        Bindi: false,
        BinisDegistiRef: 0,
        BinisDegistiFiyatli: false,
        satisTutarFake: 0,
      },
      kalemGemi: {
        GemiKod: null,
        GirisSaat: '12:00',
        Gece: 1,
        //   POdaTipi: null,
        //  PKonum: null,
        Kontenjan: 0,
        Gemi: null,
        GemiCari: null,
        GemiRezTar: null,
        GemiNo: null,
        GemiCariOnay: null,
        Acente: null,
        AcenteCari: null,
        AcenteRezTar: null,
        AcenteNo: null,
        AcenteCariOnay: null,
        Konum: null,
        OdaTipi: {
          id: null,
          isim: null,
          kod: null,
          tip: null
        },
        RP: 'T',
        DeadLine: 0,
        SanalPosIndirimTutar: 0,
        OdemeIsk_TL: 0,
        KabinSayisi: 0,
        VizeToplam: 0,
        HavaLimaniVergisi: 0,
        LimanVergisi: 0,
        EkVergi1: 0,
        EkVergi2: 0,
        EkVergi3: 0,
        PersHizBedel: 0,
        YakitFarki: 0,
        NehirVergi: 0,
        Sigorta: 0,
        VizeToplamA: 0,
        HavaLimaniVergisiA: 0,
        LimanVergisiA: 0,
        EkVergi1A: 0,
        EkVergi2A: 0,
        EkVergi3A: 0,
        PersHizBedelA: 0,
        YakitFarkiA: 0,
        NehirVergiA: 0,
        SigortaA: 0,
        CruisePaketKodu: null,
        Pansiyon: null,
      },
      kalemRehber: {
        RehberKod: null,
        IsKod: null,
        Saat: null,
        PaketDisi: null,
        Dil: null,
        IsAciklama: null,
        Rehber: null,
        RehberCari: null,
        RehberRezTar: null,
        RehberNo: null,
        RehberCariOnay: null,
        DeadLine: null
      },
      kalemAcente: {
        RP: 'T', //apideyok
        Acente: null,
        TurTipi: 0,
        Saat: null,
        Tip: null,
        Program: null,
        AcenteKodv: null,
        AcenteCari: null,
        AcenteRezTar: null,
        AcenteNo: null,
        AcenteCariOnay: null,
        AracKod: null,
        AracCari: null,
        AracRezTar: null,
        AracNo: null,
        AracCariOnay: null,
        OperKod: null,
        OperCari: null,
        OperRezTar: null,
        OperNo: null,
        OperCariOnay: null,
        DeadLine: null,
        BulusmaYeri: null,
        BulusmaTarihi: null,
        OgleYemegi: null,
        TurTuru: null,
        Girisler: null,
        DonusBilgisi: null,
        Gemi: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null,
        },
        Rehber: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null,
        },
        Arac: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null,
        },
        OtelKodu: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null,
        },
        PaketDisi: null,
        TurKodu: null,
      },
      kalemCharter: {
        UcusNo: null,
        Saat: null,
        Nerden: null,
        Nereye: null,
        Kontenjan: null,
        BiletNo: null,
        BiletNo2: null,
        HYKodu: null,
        HYKodu2: null,
        AcenteKod: null,
        CharterKod: null,
        AcenteCari: null,
        CharterCari: null,
        OperatorCari: null,
        AcenteTarih: null,
        CharterTarih: null,
        OperatorTarih: null,
        AcenteNo: null,
        CharterNo: null,
        OperatorNo: null,
        AcenteCariOnay: null,
        CharterCariOnay: null,
        OperatorCariOnay: null,
        YetiskinSticker: 0,
        YetiskinHizmet: 0,
        YetiskinTax: 0,
        CocukSticker: 0,
        CocukHizmet: 0,
        CocukTax: 0,
        BebekSticker: 0,
        BebekHizmet: 0,
        BebekTax: 0,
        CharterPTA: 0,
        DeadLine: null,
        PaketDisi: null,
        Tip: null,
      }
    }
  },

  VizeGirisTipi() {
    return [{
        text: i18n.tc('Single-entry'),
        value: 0
      },
      {
        text:i18n.tc('Multiple-entry') ,
        value: 1
      },
      {
        text: 'Transit',
        value: 2
      },
      {
        text: i18n.tc('Two-entry'),
        value: 3
      }
    ]
  },

  TurTuru() {
    return [{
        text: '',
        value: 0
      },
      {
        text: 'Private',
        value: 1
      },
      {
        text: 'Regular',
        value: 2
      },
      {
        text: 'ShorexGroup',
        value: 3
      },
      {
        text: 'PrivateSatis',
        value: 4
      },
      {
        text: 'RegularSatis',
        value: 5
      }
    ]
  },

  OdemeYeni() {
    return {
      OdemeTarihi: null,
      OdemeTipi: 0,
      NakitBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
        },
        KarsiCariAciklama: null
      },
      KrediKartBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,

        },
        KarsiCariAciklama: null,
        FirmaKrediKartli: false,
        KartNo: null,
        KartAdi: null,
        KartTipi: null,
        Banka: null,
        Taksit: 0,
        PosKodu: null,
        PosTaksit: null,
        PuanTutari: 0
      },
      HavaleBilgi: {
        Banka: null,
        Aciklama: null,
      },
      SanalPosBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
        },
        KarsiCariAciklama: null
      },
      Tutar: 0,
      ParaBirimi: 'TL',
      Kur: 1,
      OdemeIadesi: false,
      PNR_No: null,
      EvrakNo: null,
      Aciklama: null

    }
  },
  Odeme() {
    return {
      P_OdemeTipi: 3,
      P_SirketAdi: null,
      P_HesapKodu: null,
      P_Tarih: null,
      P_Evraktipi: null,
      P_b_hyolu: null,
      P_evrakno: null,
      P_faturano: null,
      P_Referans: null,
      P_Aciklama: null,
      P_Vade: null,
      P_DovizCinsi: null,
      P_DovizTutar: 0,
      P_Kur: 0,
      P_KarsiHesap: null,
      P_KarsiKebir: null,
      P_KarsiGrup: null,
      P_KarsiMuavin: null,
      P_Brut: 0,
      P_iskonto: 0,
      P_kdv: 0,
      P_CekSiraNo: null,
      P_CSTip: null,
      P_KayitTar: null,
      P_KayitKul: null,
      P_DuzeltTar: null,
      P_DuzeltKul: null,
      P_PNR_No: null,
      P_cruiseid: null,
      P_reserved1: null,
      P_faturatar: null,
      P_Ent: null,
      P_CoIslemRef: null,
      P_CoKrediKartNo: null,
      P_CoKrediKartTip: null,
      P_CoKrediKartKod: null,
      P_CoKrediKartBanka: null,
      P_CoKrediKartTaksit: null,
      P_CoKrediKartYuzde: 0,
      P_CoPNRDegisiklikNo: null,
      P_kdvoran: 0,
      P_poskod: null,
      P_bicdis: null,
      P_iadefatno: null,
      P_odemekod: null,
      P_CoIslemRefGenel: null,
      P_CoSirketNo: null,
      P_Masraf: null,
      P_taksitId: null,
      P_taksitref: null,
      P_Taksitposkod: null,
      P_bankakod: null,
      P_kotakod: null,
      P_Taksitkodlabel: null,
      P_KarsiCari: null,
      P_puantutar: 0,
      P_Karsievrak: null,
      P_Karsidvztip: null,
      P_Karsikur: 0,
      P_Karsidvztutar: 0,
      P_Karsiaciklama: null,
      P_HvAciklama: null,
      P_KrediKartNo: null,
    }
  },

  KisiAdres() {
    return {
      dialogShow: false,
      adres: this.Adres()
    }
  },



  PasaportIslemDurumu() {
    return [{
        text: i18n.tc('Was-delivered'),
        value: 0
      },
      {
        text: i18n.tc('At-Checkout-Preparation'),
        value: 1
      },
      {
        text: i18n.tc('at-the-consulate'),
        value: 2
      },
      {
        text: i18n.tc('At-checkout-transaction-ok'),
        value: 3
      }
    ]
  },

  PasaportTipi() {
    return [{
        text: 'Normal',
        value: 0
      }, {
        text: i18n.tc('Green'),
        value: 1
      }, {
        text: i18n.tc('Diplomatic'),
        value: 2
      },
      {
        text: i18n.tc('Other'),
        value: 3
      }
    ]
  },

  VizeDurumu() {
    return [{
        text: i18n.tc('Visa-Issued'),
        value: 0
      },
      {
        text: i18n.tc('in-process'),
        value: 1
      },
      {
        text: i18n.tc('Missing-document'),
        value: 2
      },
      {
        text:  i18n.tc('Rejection-Return'),
        value: 3
      },
      {
        text:  i18n.tc('In-the-office'),
        value: 4
      }
    ]
  },




  VizeTipi() {
    return [{
        text:  i18n.tc('None'),
        value: 0
      }, {
        text: i18n.tc('USA'),
        value: 1
      }, {
        text: 'Schengen',
        value: 2
      },
      {
        text: i18n.tc('individual'),
        value: 3
      },
      {
        text: i18n.tc('Private'),
        value: 4
      },

    ]
  },

  KisiTipToStr(tip) {
    if (tip == null) {
      tip = 0
    }

    return this.KisiTip[tip].Aciklama
  },

  OdeyenTarafGetir(tip) {


    if (tip == null) {
      tip = -1
    }

    return 'Ödeme ' + this.OdemeTipi[tip + 1].aciklama
  },

  PansiyonTipToStr(tip) {

    
    if (tip == null) {
      tip = 0
    }

    var varmi = this.Pansiyon.filter(function (el) {
      return el.kod == tip
    });
   
    if (varmi.length != 0) {
      return varmi[0].aciklama
    } else {
      return null
    }



  },

  SaticiTipToStr(tip) {
    // Not: SaticiTip dizisinde Kod 13 (Konsolosluk) atlandigi icin index (tip-1)
    // Sigorta/Feribot/Golf gibi 13'ten sonraki tipleri yanlis eslestiriyordu.
    var bulunan = this.SaticiTip.find(function (item) {
      return item.Kod == tip
    })
    return bulunan ? bulunan.Aciklama : ''
  },


  KisiTip: [{
    Kod: 0,
    Aciklama: i18n.tc('Adult')
  }, {
    Kod: 1,
    Aciklama: i18n.tc('child1')
  }, {
    Kod: 2,
    Aciklama: i18n.tc('child2')
  }, {
    Kod: 3,
    Aciklama: i18n.tc('child3')
  }, {
    Kod: 4,
    Aciklama: i18n.tc('child4')
  }, {
    Kod: 5,
    Aciklama: i18n.tc('Extra-Bed')
  }, ],

  SaticiTip: [{
      Aciklama: i18n.tc('Hotel'),
      Kod: 1
    },
    {
      Aciklama: i18n.tc('Transfer_lbl'),
      Kod: 2
    },
    {
      Aciklama: "Restaurant",
      Kod: 3
    },
    {
      Aciklama: i18n.tc('Agency'),
      Kod: 4
    },
    {
      Aciklama: "RentACar",
      Kod: 5
    },
    {
      Aciklama: i18n.tc('Guide'),
      Kod: 6
    },
    {
      Aciklama: i18n.tc('Museum'),
      Kod: 7
    },
    {
      Aciklama: "Charter",
      Kod: 8
    },
    {
      Aciklama: i18n.tc('Ship'),
      Kod: 9
    },
    {
      Aciklama: i18n.tc('Other'),
      Kod: 10
    },
    {
      Aciklama: i18n.tc('Visa'),
      Kod: 11
    },
    {
      Aciklama: i18n.tc('Tour-Operator'),
      Kod: 12
    },
    {
      Aciklama: i18n.tc('Insurance'),
      Kod: 14
    },
    {
      Aciklama: i18n.tc('Ferry'),
      Kod: 15
    },
    {
      Aciklama: "Golf",
      Kod: 16
    }
  ],

  saticiTipleriStr: [{
      id: 'Otel',
      text: i18n.tc('Hotel')
    },
    {
      id: 'Arac',
      text: i18n.tc('Vehicle')
    },
    {
      id: 'Restaurant',
      text: 'Restaurant'
    },
    {
      id: 'Acente',
      text: i18n.tc('Agency')
    },
    {
      id: 'RentACar',
      text: 'Ren A Car'
    },
    {
      id: 'Rehber',
      text: i18n.tc('Guide')
    },
    {
      id: 'Muze',
      text: i18n.tc('Museum')
    },
    {
      id: 'Charter',
      text: 'Charter'
    },
    {
      id: 'Gemi',
      text: i18n.tc('Ship')
    },
    {
      id: 'Diger',
      text: i18n.tc('Other')
    },
    {
      id: 'TurOperatoru',
      text: i18n.tc('Tour-Operator')
    },
    {
      id: 'Konsolosluk',
      text: i18n.tc('Consulate')
    },
    {
      id: 'Sigorta',
      text: i18n.tc('Insurance')
    },
    {
      id: 'Feribot',
      text: i18n.tc('Ferry')
    },
    {
      id: 'Golf',
      text: 'Golf'
    },
  ],

  OdemeTipi: [{
      kod: -1,
      aciklama: ""
    },
    {
      kod: 0,
      aciklama: i18n.tc('By-consumer')
    },
    {
      kod: 1,
      aciklama: i18n.tc('By-our-agency-excluding extras')
    },
    {
      kod: 2,
      aciklama: i18n.tc('Full-Credit-by-our-agency')
    },
    {
      kod: 3,
      aciklama: i18n.tc('By-Tour-Operator')
    },
  ],
  OdemeTipi: [{
      kod: -1,
      aciklama: ""
    },
    {
      kod: 0,
      aciklama: i18n.tc('By-consumer')
    },
    {
      kod: 1,
      aciklama: i18n.tc('By-our-agency-excluding extras')
    },
    {
      kod: 2,
      aciklama: i18n.tc('Full-Credit-by-our-agency')
    },
    {
      kod: 3,
      aciklama: i18n.tc('By-Tour-Operator')
    },
  ],

  Pansiyon: [{
      kod: 0, //"OB",
      aciklama: "Only Bed"
    },
    {
      kod: 1, //"BB",
      aciklama: "Bed & Breakfast"
    },
    {
      kod: 2, //"HB",
      aciklama: "Half Board"
    },
    {
      kod: 3, //"FB",
      aciklama: "Full Board"
    },
    {
      kod: 6, //"AI",
      aciklama: "All Inclusive"
    },
    {
      kod: 7, //"UAI",
      aciklama: "Ultra All Inclusive"
    }
  ],

  PansiyonWithNull: [
    {
      kod: null, 
      aciklama: i18n.tc('Hostel-Type')
    },{
    kod: 0, //"OB",
    aciklama: "Only Bed"
  },
  {
    kod: 1, //"BB",
    aciklama: "Bed & Breakfast"
  },
  {
    kod: 2, //"HB",
    aciklama: "Half Board"
  },
  {
    kod: 3, //"FB",
    aciklama: "Full Board"
  },
  {
    kod: 6, //"AI",
    aciklama: "All Inclusive"
  },
  {
    kod: 7, //"UAI",
    aciklama: "Ultra All Inclusive"
  }
],

VergiHesapTipi() {
    return [{
        text: 'Yok',
        value: 0
      }, {
        text: 'Satis Fiyatindan Hesapla',
        value: 1
      }, {
        text: 'Alis Fiyatindan Hesapla',
        value: 2
      }
    ]
  }

  


}